/* ClayGo — ürün sayfası davranışları */
(function () {
  'use strict';

  var isMobile = function () {
    return window.matchMedia('(max-width: 767.98px)').matches;
  };

  /* ---------- 12. "İlk 24 saat %50" geri sayımı ---------- */
  if (!customElements.get('claygo-countdown')) {
    customElements.define(
      'claygo-countdown',
      class ClaygoCountdown extends HTMLElement {
        connectedCallback() {
          this.clock = this.querySelector('[data-claygo-clock]');
          this.deadline = Date.now() + parseInt(this.dataset.remaining || '0', 10) * 1000;

          if (!this.clock || this.deadline <= Date.now()) {
            this.remove();
            return;
          }

          this.setAttribute('data-claygo-running', '');
          this.tick();
          this.timer = setInterval(this.tick.bind(this), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          var left = Math.floor((this.deadline - Date.now()) / 1000);
          if (left <= 0) {
            clearInterval(this.timer);
            this.remove();
            return;
          }
          var pad = function (n) {
            return n < 10 ? '0' + n : String(n);
          };
          this.clock.textContent =
            pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
        }
      }
    );
  }

  /* ---------- 15. Özel ölçü: cm² üzerinden tahmini fiyat ---------- */
  if (!customElements.get('claygo-custom-size')) {
    customElements.define(
      'claygo-custom-size',
      class ClaygoCustomSize extends HTMLElement {
        connectedCallback() {
          this.pricePerCm2 = parseFloat(this.dataset.pricePerCm2 || '0');
          this.result = this.querySelector('[data-claygo-size-result]');
          this.width = this.querySelector('[data-claygo-size-w]');
          this.height = this.querySelector('[data-claygo-size-h]');
          this.fields = Array.prototype.slice.call(
            this.querySelectorAll('input[name^="properties"], textarea[name^="properties"]')
          );

          this.onInput = this.update.bind(this);
          this.fields.forEach(
            function (field) {
              field.addEventListener('input', this.onInput);
            }.bind(this)
          );
        }

        disconnectedCallback() {
          if (!this.onInput) return;
          this.fields.forEach(
            function (field) {
              field.removeEventListener('input', this.onInput);
            }.bind(this)
          );
        }

        /* Boş alanlar sepete "En (cm): " gibi boş satır olarak gitmesin.
           Yazarken odağı kaybetmemek için sadece gönderim anında kapatılır. */
        disableEmptyFields() {
          this.fields.forEach(function (field) {
            field.disabled = field.value.trim() === '';
          });
        }

        update() {
          if (!this.result || !this.width || !this.height || !(this.pricePerCm2 > 0)) return;

          var w = parseFloat(this.width.value);
          var h = parseFloat(this.height.value);

          if (!(w > 0) || !(h > 0)) {
            this.result.hidden = true;
            return;
          }

          var total = w * h * this.pricePerCm2;
          this.result.hidden = false;
          this.result.textContent =
            'Tahmini fiyat: ' +
            total.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            ' TL (' +
            w +
            ' × ' +
            h +
            ' cm)';
        }
      }
    );
  }

  /* Sepete ekle formu gönderilmeden hemen önce boş ölçü alanlarını kapat.
     document üzerinde capture aşaması, formun kendi submit handler'ından önce çalışır. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.id) return;
      document.querySelectorAll('claygo-custom-size').forEach(function (el) {
        var field = el.querySelector('[name^="properties"]');
        if (field && field.getAttribute('form') === form.id && el.disableEmptyFields) {
          el.disableEmptyFields();
        }
      });
    },
    true
  );

  /* ---------- 19. Mobilde tam ekran sepet drawer'ı yerine küçük onay bildirimi ---------- */
  var suppressDrawer = false;
  var suppressTimer = null;
  var toast = null;
  var toastTimer = null;

  function cartUrl() {
    return (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_url) || '/cart';
  }

  function buildToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'claygo-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<span class="claygo-toast__text">Sepete eklendi</span>' +
      '<a class="claygo-toast__link" href="' +
      cartUrl() +
      '">Sepete git</a>' +
      '<button class="claygo-toast__close" type="button" aria-label="Kapat">&times;</button>';
    toast.querySelector('.claygo-toast__close').addEventListener('click', hideToast);
    document.body.appendChild(toast);
    return toast;
  }

  function showToast() {
    var el = buildToast();
    // transform geçişinin tetiklenmesi için bir kare bekle
    requestAnimationFrame(function () {
      el.setAttribute('data-open', '');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4000);
  }

  function hideToast() {
    if (toast) toast.removeAttribute('data-open');
  }

  document.addEventListener('product-ajax:added', function () {
    if (!isMobile()) return;
    suppressDrawer = true;
    showToast();
    // Bir nedenle drawer hiç açılmazsa bayrak takılı kalmasın.
    clearTimeout(suppressTimer);
    suppressTimer = setTimeout(function () {
      suppressDrawer = false;
    }, 2500);
  });

  customElements.whenDefined('cart-drawer').then(function () {
    var CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.prototype.__claygoPatched) return;

    var originalShow = CartDrawer.prototype.show;
    CartDrawer.prototype.show = function (focusElement, animate) {
      if (suppressDrawer) {
        suppressDrawer = false;
        clearTimeout(suppressTimer);
        return;
      }
      return originalShow.call(this, focusElement, animate);
    };
    CartDrawer.prototype.__claygoPatched = true;
  });

  /* ---------- 5. Ürün Kodu: ilk varyant SKU'suna sabitle ----------
     Tema product-info.js varyant değişiminde #Sku-* içeriğini yeniden yazar.
     İlk yüklemedeki sabit SKU'yu saklayıp her variantChange sonrası geri yazarız. */
  var fixedSkus = new Map();

  function captureFixedSku(root) {
    (root || document).querySelectorAll('[data-claygo-sku-fixed]').forEach(function (el) {
      if (!el.id || fixedSkus.has(el.id)) return;
      fixedSkus.set(el.id, el.innerHTML);
    });
  }

  function restoreFixedSkus() {
    fixedSkus.forEach(function (html, id) {
      var el = document.getElementById(id);
      if (el) el.innerHTML = html;
    });
  }

  captureFixedSku(document);

  document.addEventListener('variant:changed', function () {
    // Section rendering fiyat + badge'i zaten günceller; SKU'yu sabitle.
    requestAnimationFrame(function () {
      restoreFixedSkus();
    });
  });

  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
      requestAnimationFrame(function () {
        restoreFixedSkus();
      });
    });
  }

  /* ---------- Sticky sepet kutusu + WhatsApp balonu: yükseklik senkronu ----------
     Kutu içeriği (uzun ürün / varyant adı) yüksekliği değiştirdiğinde iki öğe de
     gerçek ölçülere göre yer değiştirsin; sabit offset çakışma üretiyor. */
  var stickyVars = {
    bar: '--claygo-atc-height',
    wa: '--claygo-wa-height',
  };

  function measureStickyOffsets() {
    var root = document.documentElement;
    var bar = document.querySelector('.sticky-atc-bar');
    var wa = document.querySelector('.claygo-wa');
    var barHeight = 0;

    // display:none ise offsetHeight 0 döner; ayrıca kutu kapalıyken offset eklemeyiz.
    if (bar && bar.classList.contains('sticky-atc-bar--show')) {
      barHeight = Math.ceil(bar.getBoundingClientRect().height);
    }

    root.style.setProperty(stickyVars.bar, barHeight + 'px');
    root.style.setProperty(stickyVars.wa, wa ? wa.offsetHeight + 'px' : '0px');
  }

  var stickyRaf = null;
  function scheduleStickyMeasure() {
    if (stickyRaf) return;
    stickyRaf = requestAnimationFrame(function () {
      stickyRaf = null;
      measureStickyOffsets();
    });
  }

  function watchStickyOffsets() {
    var bar = document.querySelector('.sticky-atc-bar');
    if (!bar) return;

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(scheduleStickyMeasure);
      resizeObserver.observe(bar);
      var wa = document.querySelector('.claygo-wa');
      if (wa) resizeObserver.observe(wa);
    }

    // Kutu açılıp kapandığında class değişir; yüksekliği o an yeniden ölç.
    new MutationObserver(scheduleStickyMeasure).observe(bar, {
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    window.addEventListener('resize', scheduleStickyMeasure);
    document.addEventListener('variant:changed', scheduleStickyMeasure);
    scheduleStickyMeasure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchStickyOffsets);
  } else {
    watchStickyOffsets();
  }

  // product-info yeniden mount olduğunda (quick-view vs.) yeni SKU düğümlerini yakala
  var skuObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-claygo-sku-fixed]')) {
          captureFixedSku(node.parentElement || document);
        } else if (node.querySelectorAll) {
          captureFixedSku(node);
        }
      });
    });
  });
  skuObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
